import { Link } from 'react-router-dom'

export function SiteFooter() {
  return (
    <footer className="border-t border-stone-100 bg-stone-50 px-4 py-6 mt-auto">
      <div className="max-w-5xl mx-auto text-center space-y-2">
        <p className="text-xs text-stone-500">
          Magar–Nepali–English Dictionary · Community Review Edition
        </p>
        <p className="text-xs text-stone-400">
          <Link to="/about" className="underline hover:text-stone-600">
            About &amp; Credits
          </Link>
          {' '}·{' '}
          <Link to="/" className="hover:text-stone-600">
            Search
          </Link>
        </p>
      </div>
    </footer>
  )
}
